const postMessage = (payload, result) => {
  self.postMessage({
    action: 'jsonResult',
    payload,
    result,
  });
};

const messageHandler = (e) => {
  if (!e.data.payload) {
    return;
  }

  switch (e.data.action) {
    default:
      break;

    case 'parse':
      postMessage(e.data.payload, JSON.parse(e.data.payload));
      break;

    case 'stringify':
      postMessage(e.data.payload, JSON.stringify(e.data.payload, null, 2));
      break;
  }
};

self.addEventListener('message', messageHandler);



// WEBPACK FOOTER //
// ./src/js/webworkers/json-worker.js